import { MCP_OAUTH_SCOPES, MCP_SERVER_NAME } from '../constants/mcpOAuth';

export interface CursorMcpInstallConfig {
  url: string;
  auth?: {
    CLIENT_ID: string;
    scopes?: string[];
  };
}

export interface BuildCursorMcpInstallUrlOptions {
  mcpUrl: string;
  clientId: string;
  serverName?: string;
}

export function buildCursorMcpInstallConfig(
  options: BuildCursorMcpInstallUrlOptions,
): CursorMcpInstallConfig {
  return {
    url: options.mcpUrl,
    auth: {
      CLIENT_ID: options.clientId,
      scopes: [...MCP_OAUTH_SCOPES],
    },
  };
}

export function buildCursorMcpInstallUrl(options: BuildCursorMcpInstallUrlOptions): string {
  const config = buildCursorMcpInstallConfig(options);
  const encoded = btoa(JSON.stringify(config));
  const name = encodeURIComponent(options.serverName ?? MCP_SERVER_NAME);
  return `cursor://anysphere.cursor-deeplink/mcp/install?name=${name}&config=${encoded}`;
}
